exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_listElementHeader_2Exu-200puWc4hFh5s___d {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  overflow: hidden;\n  font-size: 12px;\n  padding-left: 15px;\n  box-sizing: border-box;\n}\n\n.IA_previewColumn_2lmWMSqQFPyAnpEreEae3f {\n  flex: 0.2;\n}\n\n.IA_iconColumn_1fhLvCPCLTwmAsrQmzbi21 {\n  flex: 0.4;\n  padding-right: 10px;\n  box-sizing: border-box;\n}\n\n.IA_dateColumn_LtcWMF3ag2pegSmN_DChD {\n  flex: 0.5;\n}\n\n.IA_column_AiN2jJOrd8T0R6F0q6cNH {\n  flex: 1;\n}\n\n.IA_buttons_2UI3UCoy6SF7HgeRekVvWi {\n  padding-right: 10px;\n}", ""]);

// Exports
exports.locals = {
	"IA_listElementHeader": "IA_listElementHeader_2Exu-200puWc4hFh5s___d",
	"IA_previewColumn": "IA_previewColumn_2lmWMSqQFPyAnpEreEae3f",
	"IA_iconColumn": "IA_iconColumn_1fhLvCPCLTwmAsrQmzbi21",
	"IA_dateColumn": "IA_dateColumn_LtcWMF3ag2pegSmN_DChD",
	"IA_column": "IA_column_AiN2jJOrd8T0R6F0q6cNH",
	"IA_buttons": "IA_buttons_2UI3UCoy6SF7HgeRekVvWi"
};